<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <v-dialog
    v-model="realValue"
    max-width="800"
    persistent
  >
    <v-card
      class="guide3Step4"
      style="position: relative;"
    >
      <div class="d-flex align-center pa-4">
        <div class="text-h3 font-weight-bold">
          {{ $t('newProduct') }}
        </div>
        <v-spacer />
        <div>
          <v-btn
            icon
            @click="realCloseDialog()"
          >
            <v-icon large>
              mdi-close
            </v-icon>
          </v-btn>
        </div>
      </div>
      <div class="pa-4">
        <template v-if="!loading">
          <v-form
            ref="stepOneForm"
            v-model="valid"
            lazy-validation
          >
            <template v-for="(field,index) in groupedFields">
              <div
                v-if="editedItem[field.value]"
                :key="field.value+index+'group'"
              >
                <div class="d-flex align-center">
                  <div>
                    <div class="text-h4 font-weight-medium">
                      {{ $t('' + field.groupName) }}
                    </div>
                    <div
                      v-if="!$vuetify.breakpoint.mobile"
                      class="text-caption"
                    >
                      {{ $t('other_lang_could_not_be_filled_if_not_fill_just_one_lang_can_be_used') }}
                    </div>
                  </div>
                  <v-spacer />
                  <div class="d-flex">
                    <div>
                      <v-tabs
                        v-model="langTab"
                        color="#232123"
                        height="36px"
                        style="background: transparent!important;"
                      >
                        <v-tab
                          v-for="(child,i) in field.children"
                          :key="field.value+'c'+editedItem[field.value][i][field.childLabelKey]+'tab'"
                        >
                          {{ $t(editedItem[field.value][i][field.childLabelKey].toLowerCase()) }}
                          <span
                            v-if="i===0"
                            class="red--text"
                          > * </span>
                        </v-tab>
                      </v-tabs>
                    </div>
                  </div>
                </div>
                <v-tabs-items
                  v-model="langTab"
                  class="mt-4"
                >
                  <v-tab-item
                    v-for="(child,i) in field.children"
                    :key="i+'dishId'"
                  >
                    <template v-for="(c,t) in child">
                      <div :key="field.id+'t'+t+'c'+i">
                        <form-field
                          v-if="editedItem[field.value]"
                          :current-state="-1"
                          :edited-item="editedItem[field.value][i]"
                          :field="c"
                          no-details
                        />
                      </div>
                    </template>
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </template>
            <div
              :style="$vuetify.breakpoint.mobile?'grid-template-columns: repeat(1,minmax(0,1fr))':'grid-template-columns: repeat(1,minmax(0,1fr))'"
              style="display: grid;grid-gap: 16px"
            >
              <template v-for="(field,index) in normalInformation">
                <div
                  :key="'f1'+index+field.text"
                >
                  <form-field
                    :current-state="-1"
                    :edited-item="editedItem"
                    :field="field"
                    no-details
                    @click="addNew(-1)"
                  />
                </div>
              </template>
            </div>
          </v-form>

          <div>
            <v-btn
              :disabled="!valid"
              class="amber lighten-4 black--text mr-4 guide3Step5 "
              depressed
              @click="save"
            >
              {{ $t('save') }}
            </v-btn>
            <v-btn
              :disabled="!valid"
              depressed
              outlined
              @click="saveAndNew"
            >
              {{ $t('saveAndAdd') }}
            </v-btn>
          </div>
        </template>
        <template v-else>
          <div
            class="d-flex align-center justify-center"
            style="height: 300px"
          >
            <v-progress-circular
              indeterminate
              size="64"
            />
          </div>
        </template>
      </div>

      <ik-entity-form
        v-model="showCategoryDialog"
        :edited-index="activeCategoryIndex"
        :model="categoryModel"
        :title="$t('category')"
        @need-refresh="loadCategory"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import Dish from '@/model/dataLayer/api/dish/Dish'
import IKUtils from 'innerken-js-utils'
import Category from '@/model/dataLayer/api/dish/Category'
import { copyToAll, showSuccessMessage } from '@/model/utils/utils'
import PrinterGroup from '@/model/dataLayer/api/print/PrinterGroup'
import ConsumeType from '@/model/dataLayer/api/buffet/ConsumeType'
import DishesConsumeType from '@/model/dataLayer/api/buffet/DishesConsumeType'
import IkEntityForm from '@/plugins/EntityFrameWork/IkEntityForm.vue'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import FormField from '@/plugins/EntityFrameWork/FormField.vue'

export default {
  name: 'AddNewDishDialog',
  components: {
    IkEntityForm,
    FormField
  },
  props: {
    dialogGuide: {},
    newProductCode: {},
    value: {
      default: null,
      type: Boolean
    }
  },
  data () {
    return {
      realValue: null,

      showCategoryDialog: null,
      activeCategoryIndex: null,
      categoryModel: Category,

      loading: true,
      langTab: null,
      model: Dish,
      editedIndex: -1,
      tab: 0,
      valid: true,
      formField: [],
      currentList: [],
      IKDataEntity,
      defaultItem: null,
      calculateDefaultItem: null,
      editedItem: null,
      keyStore: {}

    }
  },
  computed: {
    normalInformation () {
      return this.requiredFields.filter(
        f => f.value === 'code' || f.value === 'price' || f.value === 'categoryId' || f.value === 'printGroupId' || f.value === 'cookingTime')
    },
    requiredFields () {
      return this.notGroupedFields.filter(f => this.fieldIsRequired(f))
    },

    groupedFields: function () {
      return this.notImageField.filter(f => f.dataType === IKDataEntity.Types.Group)
    },
    notGroupedFields: function () {
      return this.notImageField.filter(f => f.dataType !== IKDataEntity.Types.Group)
    },
    uniqueField: function () {
      return this.formField.filter(f => f.unique)
    },
    notImageField: function () {
      return this.formField.filter(f => f.dataType !==
          IKDataEntity.Types.Image)
    },
    name () {
      return (this?.editedItem?.name ?? this.editedItem?.dishName ?? this.$t('loading'))
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.realValue = val
      }
    },
    async realValue (val, old) {
      if (val !== old) {
        this.$emit('input', val)
      }
      if (val) {
        await this.reload()
      }
    }
  },
  async mounted () {
    await this.wait(async () => {
      [, this.formField, this.calculateDefaultItem] = await IKDataEntity.parseField(this.model)
      Object.freeze(this.calculateDefaultItem)
      console.log(this.calculateDefaultItem)

      this.categoryList = (await Category.getList(true))
      this.printerList = (await PrinterGroup.getList(true))

      await this.reload()
    })
  },
  methods: {
    async realCloseDialog (code) {
      this.$emit('close', code)
    },
    async saveDish () {
      let newItem = []
      console.log('run')
      for (const f of this.groupedFields) {
        copyToAll(f, this.editedItem[f.value])
      }
      await this.wait(async () => {
        newItem = (await Dish.add({
          ...this.editedItem
        }))
        const needShowConsumeType = (await ConsumeType.getList(true)).map(it => it.id)
          .filter(x => x !== 1 && x !== 2 && x !== 5)
        for (const id of needShowConsumeType) {
          await DishesConsumeType.edit({
            dishId: newItem.id,
            showing: false,
            consumeTypeId: id
          })
        }
        await this.reload()
        showSuccessMessage(this.$t('addSuccess'))
      })
      return newItem
    },
    async saveAndNew () {
      if (this.$refs.stepOneForm.validate()) {
        await this.saveDish()
      }
    },
    async save () {
      if (this.$refs.stepOneForm.validate()) {
        const item = await this.saveDish()
        console.log(item)
        await this.realCloseDialog(item)
      }
    },

    async reload () {
      await this.initialForm()
      setTimeout(async () => {
        if (this.uniqueField.length > 0) {
          this.keyStore = {}
          this.keyStore = await this.uniqueField.reduce(async (obj, i) => {
            const trackingList = i.uniqueTrackingList ? await i.uniqueTrackingList() : this.currentList
            obj[i.value] = trackingList.map(it => it[i.value]).filter(it => it !== this.editedItem[i.value])
            return obj
          }, {})
          this.uniqueField.forEach(it => {
            it.rule = []
            if (this.keyStore[it.value]) {
              const uniqueCheck = val => (this.keyStore[it.value] && !this.keyStore[it.value].includes(
                val)) || this.$t(
                it.text) + ': ' + val + ' ' + this.$t('AlreadyInUse')
              this.$set(it, 'rule', [...it.rule, uniqueCheck])
            }
          })
        }
      }, 100)
    },

    async loadCategory (item) {
      this.editedItem.categoryId = parseInt(item.content.id)
      this.categoryList = await Category.getList(true)
      this.step = 3
    },
    async addNew (index) {
      this.showCategoryDialog = true
      this.activeCategoryIndex = index
    },

    resetDefaultItem () {
      this.defaultItem = this.calculateDefaultItem
    },

    fieldIsRequired (field) {
      return field.required && ((field.requiredNew))
    },

    async initialForm () {
      this.currentList = this.outSideList ?? await IKUtils.safeCallFunction(this.model, this.model.getList, true)

      this.resetDefaultItem()
      if (!this.loading) {
        return
      }
      this.editedItem = IKUtils.deepCopy(this.defaultItem)
      if (this.editedItem) {
        this.editedItem.code = this.newProductCode
      }
    },

    async wait (action) {
      this.loading = true
      try {
        await action()
      } catch (e) {

      }
      this.loading = false
    }

  }
}
</script>

<style>

</style>
